/**
 * Selection click logic from the prototype: shift-click selects the whole range between the last clicked tile and this
 * one (in result order); any other click toggles the tile.
 */
export function applySelectionClick(
  selected: ReadonlySet<string>,
  orderedIds: readonly string[],
  id: string,
  lastClicked: string | null,
  shift: boolean,
): Set<string> {
  const next = new Set(selected);
  if (shift && lastClicked) {
    const a = orderedIds.indexOf(lastClicked);
    const b = orderedIds.indexOf(id);
    if (a !== -1 && b !== -1) {
      for (const x of orderedIds.slice(Math.min(a, b), Math.max(a, b) + 1)) next.add(x);
      return next;
    }
  }
  if (next.has(id)) next.delete(id);
  else next.add(id);
  return next;
}

/** "Select day": selects every photo of the day, or clears them when they're all selected already. */
export function toggleGroup(selected: ReadonlySet<string>, ids: readonly string[]): Set<string> {
  const next = new Set(selected);
  const all = ids.every((id) => next.has(id));
  for (const id of ids) {
    if (all) next.delete(id);
    else next.add(id);
  }
  return next;
}
